import { createFileRoute } from "@tanstack/react-router";
import {
  OneOffRevenueGuard,
  OneOffRevenueReport,
} from "@/features/office/reports/one-off-revenue";

export const routeId = "/office/reports/one-off-revenue";

export const Route = createFileRoute("/office/reports/one-off-revenue")({
  component: () => (
    <OneOffRevenueGuard>
      <OneOffRevenueReport />
    </OneOffRevenueGuard>
  ),
});
